import borg from "./borg";
import app from "./app";
import env from "./env";
import machine from "./machine";
import process from "./process";
import role from "./role";
import scope from "./scope";
import externalResource from "./external-resources";

const withExternalResources = (definition) => ({
  ...definition,
  collections: {
    ...definition.collections,
    externalResources: { objectType: "externalResource" },
  },
});

// start off schema with structure info
const schema = {
  collections: {
    apps: { objectType: "app" },
    externalResources: { objectType: "externalResource" },
  },
  objectTypes: {
    borg,
    app: withExternalResources(app),
    env: withExternalResources(env),
    machine: withExternalResources(machine),
    process: withExternalResources(process),
    role: withExternalResources(role),
    scope: withExternalResources(scope),
    externalResource: withExternalResources(externalResource),
  },
};

export default schema;
